import React, {Fragment} from 'react';
import Navbar3 from '../../components/Navbar3/Navbar3';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import TeamSection from '../../components/TeamSection/TeamSection';
import Subscribe from '../../components/Subscribe/Subscribe';
import Footer from '../../components/footer/Footer';


const TeamPage =() => {
    return(
        <Fragment>
            <Navbar3 topbarNone={'wpo-header-style-6'}/>
            <PageTitle pageTitle={'Projects'} pagesub={'Project'}/> 
            <TeamSection tClass={'wpo-team-section-s3'}/>
            <Subscribe sbClass={'wpo-subscribe-section-s2'}/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default TeamPage;
